import { CreateListContractor, UploadContractorFormFile } from "../../../reduxToolkit/Files/FilesApi"; // Importing API actions for uploading a file and creating a list of contractors
import { toast } from "react-toastify"; // Importing toast notifications for user feedback
import routes from "../../../Routes/routes";
import {errorMsg} from "../../../Apis/functions"; // Importing route definitions for navigation

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

// Main component that manages error handling and confirmation during contractor creation
export const CreationErrorsContractorApp = ({ t, dispatch, navigate, spreadsheetData, data, setUpdate, getFormData, isValidFile }) => {

    // Function to handle file upload process
    const handleUploadFile = () => {
        setUpdate(true); // Set update flag to true (possibly to show a loading indicator or re-fetch UI)

        if (spreadsheetData) { // Check if there is spreadsheet data to upload
            let data = getFormData(); // Get form data prepared for upload (e.g., FormData object)

            if (data) {
                dispatch(UploadContractorFormFile(data)) // Dispatch Redux action to upload the file
                    .then(
                        ({
                             payload: {
                                 data: { data, success },
                             },
                         }) => {
                            // If upload is successful, pass the returned data to the file validation callback
                            if (success === true) {
                                isValidFile(data);
                            }
                        },
                    )
                    .catch((error) => {
                        // Show an error toast if upload fails
                        toast.error(t('fail_to_upload_file').toUpperCase());
                    });
            }
        } else {
            // Show a warning toast if no file is selected for upload
            toast?.warn(t('there_is_not_file_to_upload').toUpperCase());
        }
    };

    // Function to confirm contractor creation after file validation
    const handleConfirm = () => {
        dispatch(CreateListContractor(data)).then(({ payload: { data: { success, code } } }) => {
            if (success === true) {
                // Show success toast and navigate to the contractor list route
                toast.success(t('has_been_created_successfully'));
                navigate(routes.contractor.list);
            } else errorMsg(code)
        });
    };

    // Return the handlers to be used in the UI or parent components
    return {
        handleConfirm,
        handleUploadFile
    };
};

// Exporting the component so it can be used in other parts of the application
export default CreationErrorsContractorApp;
